<template>
  <router-link style="text-decoration: unset" to="/" class="inline-block">
    <q-img
      :src="require('src/assets/logos/campertrader_logo_ocean_w_text.svg')"
      alt="Camper Trader Logo" fit="contain"
      :width="width"/>
  </router-link>
</template>

<script setup>
defineProps({
  dark: Boolean,
  width: {
    type: String,
    default: '300px'
  }
})

</script>

<style scoped>

</style>
